import React from 'react';
import { Eyebrow, Heading, Text } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

interface SectionHeadingProps {
  heading: string;
  eyebrow?: string;
  subtitle?: string;
  containerStyles?: React.CSSProperties;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  heading,
  eyebrow,
  subtitle,
  containerStyles: containerStylesProp,
}) => (
  <div css={containerStyles} style={containerStylesProp}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <div css={innerContainerStyles}>
      <Heading level={2}>{heading}</Heading>
      {subtitle && <Text size="large">{subtitle}</Text>}
    </div>
  </div>
);

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '652px',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  margin: '0 auto',
});

const innerContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.100'),
});

export default SectionHeading;
